import { css } from '@emotion/react';

const makeNavigationBarStyling = ({ theme }) => {
  return {
    box: css({
      marginTop: theme.mvf.spacing.tiny,
      marginBottom: theme.mvf.spacing.medium,
      height: 45,
      [theme.breakpoints.up('tabletSmall')]: {
        height: 55,
      },
    }),
  };
};

export default makeNavigationBarStyling;
